















































































































































































































































































































import { Paths } from '@/router';
import {
  WorksheetsService,
  IWorksheet,
  ICreateWorklogRequest,
  ICreateMaterialRequest,
  IUpdatableWorksheet,
} from '@/services/WorksheetsService';
import BButton from 'buefy/src/components/button/Button.vue';
import BTableColumn from 'buefy/src/components/table/TableColumn.vue';
import { Component, Vue } from 'vue-property-decorator';

function currentDateString(): string {
  const date = new Date();

  return `${date.getDate()}. ${date.getMonth() + 1}. ${date.getFullYear()}`;
}

function createEmptyWorklog(current: number): ICreateWorklogRequest {
  return {
    date: currentDateString(),
    description: '',
    hours: '',
    sort_order: current + 1,
  };
}

function createEmptyMaterial(current: number): ICreateMaterialRequest {
  return {
    description: '',
    emId: '',
    quantity: '',
    sort_order: current + 1,
  };
}

@Component({
  components: { BTableColumn, BButton },
})
export default class Home extends Vue {
  private padStyle: any = {
    ['background-color']: 'white',
  };

  private loaded = false;
  private worksheet: IUpdatableWorksheet | null = null;
  private worklog: ICreateWorklogRequest | null = null;
  private material: ICreateMaterialRequest | null = null;

  private async mounted() {
      this.worksheet = await WorksheetsService.getWorksheet(parseInt(this.$route.params.worklogId, 10));
      console.log(this.worksheet);
      this.clearWorklog();
      this.clearMaterial();
      this.loaded = true;
  }

  private async updated() {
      if ( this.worksheet !== null && this.worksheet !== undefined && (this.$refs as any).signaturePad !== undefined) {
          const signaturePad = (this.$refs as any).signaturePad;
          if (signaturePad.isEmpty()) {
              signaturePad.fromDataURL(this.worksheet!.customerSignatureImage);
          }
      }
  }

  private reorder(toBeSorted: Array<{ sort_order?: number }>) {
    toBeSorted.sort((a, b) => (a.sort_order as number) - (b.sort_order as number));
    for (let i = 1; i <= toBeSorted.length; ++i) {
      toBeSorted[i - 1].sort_order = i;
    }
  }

  private calcCurrent(all: Array<{ sort_order?: number }>): number {
    const sortOrders = all.map((m) => m.sort_order as number);
    return sortOrders.length === 0 ?
      0
      :
      Math.max(...sortOrders);
  }

  private clearMaterial() {
    this.material = createEmptyMaterial(this.calcCurrent(this.worksheet!.materials));
  }

  private storeMaterial() {
      this.worksheet!.materials.push(this.material!);
      this.clearMaterial();
  }

  private removeMaterial(sortOrder: number) {
    this.worksheet!.materials = this.worksheet!.materials.filter((m) => m.sort_order !== sortOrder);
    this.reorder(this.worksheet!.materials);
    this.material!.sort_order = this.calcCurrent(this.worksheet!.materials) + 1;
  }

  private moveMaterial(up: boolean, sortOrder: number) {
    const current = this.worksheet!.materials.filter((m) => m.sort_order === sortOrder)[0];
    const toSwitch = up ?
      this.worksheet!.materials.filter((m) => m.sort_order === sortOrder - 1)[0]
      :
      this.worksheet!.materials.filter((m) => m.sort_order === sortOrder + 1)[0];
    current.sort_order = toSwitch.sort_order;
    toSwitch.sort_order = sortOrder;

    this.worksheet!.materials.sort((a, b) => (a.sort_order as number) - (b.sort_order as number));
  }

  private clearWorklog() {
    this.worklog = createEmptyWorklog(this.calcCurrent(this.worksheet!.worklogs));
  }

  private storeWorklog() {
    this.worksheet!.worklogs.push(this.worklog!);
    this.clearWorklog();
  }

  private removeWorklog(sortOrder: number) {
    this.worksheet!.worklogs = this.worksheet!.worklogs.filter((m) => m.sort_order !== sortOrder);
    this.reorder(this.worksheet!.worklogs);
    this.worklog!.sort_order = this.calcCurrent(this.worksheet!.worklogs) + 1;
  }

  private moveWorklog(up: boolean, sortOrder: number) {
    const current = this.worksheet!.worklogs.filter((m) => m.sort_order === sortOrder)[0];
    const toSwitch = up ?
      this.worksheet!.worklogs.filter((m) => m.sort_order === sortOrder - 1)[0]
      :
      this.worksheet!.worklogs.filter((m) => m.sort_order === sortOrder + 1)[0];
    current.sort_order = toSwitch.sort_order;
    toSwitch.sort_order = sortOrder;

    this.worksheet!.worklogs.sort((a, b) => (a.sort_order as number) - (b.sort_order as number));
  }

  private validate(): boolean {
    const missingFields: string[] = [];
    let result = true;

    if (this.worksheet!.customerName === null || this.worksheet!.customerName === undefined ||
    this.worksheet!.customerName.trim().length === 0) {
      missingFields.push('ime stranke');
      result = false;
    }

    if ((this.$refs as any).signaturePad.isEmpty()) {
      missingFields.push('podpis stranke');
      result = false;
    }

    if (!result) {
      this.$snackbar.open({
        message: `Potrebno je izpolniti naslednja polja: ${missingFields.join(', ')}.`,
        type: 'is-warning',
        position: 'is-top',
        indefinite: false,
        duration: 5000,
      });
    }

    return result;
  }

  private undo() {
    (this.$refs as any).signaturePad.undoSignature();
  }

  private async save() {
    if (this.validate()) {
      const { data } = (this.$refs as any).signaturePad.saveSignature();

      this.worksheet!.customerSignatureImage = data;
      try {
        await WorksheetsService.updateWorksheet(this.worksheet!);
        this.$router.push({ name: Paths.WORK_LOGS });
      } catch (err) {
        console.error('Something went wrong while creating a new worksheet!', err);
      }
    }
  }

  private async goBack() {
      this.$router.push({ name: Paths.WORK_LOGS });
  }
}
